import script from "./product7View.vue?vue&type=script&setup=true&lang=js"
export * from "./product7View.vue?vue&type=script&setup=true&lang=js"

import "./product7View.vue?vue&type=style&index=0&id=68dc3a9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68dc3a9e"]])

export default __exports__